import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../../components/Button";
import CustomTextField from "../../../components/Textfield";
import { getSx } from "../../../components/Modal/style";
import { useDispatch } from "react-redux";
import UploadImage from "../../../components/UploadImage";
import * as Yup from "yup";
import {
  addFile,
  addResource,
  addSponsor,
  deleteFile,
  updateResource,
  updateSponsor,
} from "../../../http/auth";
import { useFormik } from "formik";
import Spinner from "../../../components/Spinner";
import { showToast } from "../../../store/slices/common";
import CustomTextArea from "../../../components/Textarea";
import { validateFileSize, validateImageDimensions } from "./validationHelpers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "600px",
    padding: "30px",
    borderRadius: "20px",
  },
  "& .MuiPaper-root": { maxWidth: "600px" },
  "& .MuiDialogActions-root": {},
}));

export default function AddResourceModal({
  open,
  setOpen,
  resource,
  getResourceList,
  isEdit,
  isView,
  setPage,
}) {
  const [loading, setLoading] = useState(false);
  const classes = getSx(true);
  const dispatch = useDispatch();

  console.log(resource, "resourcehk");
  const initialValues = {
    image: resource?.image || "",
    description: {
      en: resource?.description?.en || "",
      hi: resource?.description?.hi || "",
      fr: resource?.description?.fr || "",
      es: resource?.description?.es || "",
    },
    link: resource?.link || "",
  };

  const validationSchema = Yup.object({
    image: Yup.string().required("Image is required"),
    // description: Yup.string().required("Description is required"),
    link: Yup.string().required("Link is required").url("Invalid link"),
  });

  const handleChange = (e) => {
    if (e.target.value.length <= 150) {
      const desc = { ...formik.values.description };
      console.log(desc, "decsdsf");
      formik.setFieldValue("description", {
        ...desc,
        [e.target.name]: e.target.value,
      });
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        console.log(values);
        setLoading(true);
        const res = isEdit
          ? await updateResource({ ...values, resourceId: resource.id })
          : await addResource(values);
        !isEdit && setPage(1);
        isEdit ? await getResourceList() : await getResourceList(1);
        dispatch(showToast({ color: "success", msg: res.data.message?.en }));
        closeModalHandler();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        // dispatch(showToast({ color: "error", msg: error?.response?.data?.message || "Something went wrong" }));
      }
    },
  });

  const closeModalHandler = () => {
    setOpen(false);
  };

  const handleFileUpload = (file) => {
    setLoading(true);
    console.log(file);
    if (!validateFileSize(file)) {
      dispatch(
        showToast({ color: "error", msg: "File size should not exceed 50MB" })
      );
      setLoading(false);
      return;
    }

    // Validate image dimensions
    validateImageDimensions(file, (isValid) => {
      if (!isValid) {
        dispatch(
          showToast({
            color: "error",
            msg: "Image must be of resolution 220x220 pixels",
          })
        );
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      addFile(formData)
        .then((res) => {
          formik.setFieldValue("image", res?.data?.data?.fileUrl);
          dispatch(showToast({ color: "success", msg: res.data.message?.en }));
        })
        .catch((err) => {
          console.log(err);
          dispatch(showToast({ color: "error", msg: "Something went wrong" }));
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const handleFileDelete = async (setPreview) => {
    setLoading(true);
    try {
      const payload = { fileUrl: formik.values.image };
      const res = await deleteFile(payload);
      dispatch(showToast({ color: "success", msg: res.data.message?.en }));
      formik.setFieldValue("image", "");
    } catch (err) {
      console.log(err);
      // dispatch(showToast({ color: "error", msg: "something went wrong" }))
    } finally {
      setLoading(false);
    }
  };

  const getDisabled = () => {
    if (isEdit) {
      const noChange =
        formik.values.image === resource.image &&
        formik.values.link === resource.link &&
        formik.values.description === resource.description;
      const disabled =
        !formik.values.image ||
        !formik.values.link ||
        !formik.values.description ||
        noChange;
      return disabled;
    } else
      return (
        !formik.values.image ||
        !formik.values.link ||
        !formik.values.description
      );
  };

  const limit1 = 150 - (formik?.values?.description?.en?.length || 0);
  const limit2 = 150 - (formik?.values?.description?.hi?.length || 0);
  const limit3 = 150 - (formik?.values?.description?.fr?.length || 0);
  const limit4 = 150 - (formik?.values?.description?.es?.length || 0);
  const color1 = limit1 === 0 ? "red" : "#e7e71b";
  const color2 = limit2 === 0 ? "red" : "#e7e71b";
  const color3 = limit3 === 0 ? "red" : "#e7e71b";
  const color4 = limit4 === 0 ? "red" : "#e7e71b";
  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "600px",
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {loading && <Spinner />}
      <form onSubmit={formik.handleSubmit}>
        <DialogContent sx={{ padding: "8px 20px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              minWidth: "300px",
              maxWidth: "600px",
              textAlign: "center",
            }}
          >
            {isEdit ? "Update Resource" : "Add Resource"}
          </Typography>
          <Box
            display="flex"
            maxWidth="600px"
            flexDirection="column"
            padding={{ xs: "0", md: "0 20px" }}
          >
            {loading && <Spinner />}
            <Box
              sx={{
                height: "fit-content",
                display: "flex",
                justifyContent: "flex-start",
                gap: "2rem",
                overflow: "auto",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "8px",
                  width: "100%",
                }}
              >
                <UploadImage
                  style={{
                    height: "120px",
                    width: "150px",
                    marginBottom: 0,
                    iconWidth: "32px",
                    iconHeight: "32px",
                    iconRight: "-18px",
                  }}
                  id="sponsorImg"
                  image={formik.values.image}
                  // disabled={!edit}
                  onChange={handleFileUpload}
                  onDelete={handleFileDelete}
                  name="sponsorImg"
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    opacity: "0.5",
                  }}
                >
                  Image must be of resolution 220x220
                </Typography>
                <Box
                  display="flex"
                  flexDirection="column"
                  width="90%"
                  padding="20px"
                >
                  {loading && <Spinner />}
                  <Typography
                    sx={{
                      fontSize: "18px",
                      minWidth: "300px",
                    }}
                  >
                    Description<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextArea
                      type="text"
                      name="en"
                      from="faq"
                      placeholder="Description in english"
                      value={formik.values.description?.en}
                      onChange={handleChange}
                    />
                  </Box>
                  {(isEdit || !resource) && (
                    <Typography
                      sx={{
                        color: color1,
                        textAlign: "right",
                        fontWeight: 400,
                        px: 1,
                      }}
                    >
                      {`${limit1} /150`}
                    </Typography>
                  )}
                  <Box
                    borderRadius="40px"
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextArea
                      type="text"
                      name="hi"
                      from="faq"
                      placeholder="Description in hindi"
                      value={formik.values.description?.hi}
                      onChange={handleChange}
                    />
                  </Box>
                  {(isEdit || !resource) && (
                    <Typography
                      sx={{
                        color: color2,
                        textAlign: "right",
                        fontWeight: 400,
                        px: 1,
                      }}
                    >
                      {`${limit2} /150`}
                    </Typography>
                  )}
                  <Box
                    borderRadius="40px"
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextArea
                      type="text"
                      name="fr"
                      from="faq"
                      placeholder="Description in french"
                      value={formik.values.description?.fr}
                      onChange={handleChange}
                    />
                  </Box>
                  {(isEdit || !resource) && (
                    <Typography
                      sx={{
                        color: color3,
                        textAlign: "right",
                        fontWeight: 400,
                        px: 1,
                      }}
                    >
                      {`${limit3} /150`}
                    </Typography>
                  )}
                  <Box
                    borderRadius="40px"
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextArea
                      type="text"
                      name="es"
                      from="faq"
                      placeholder="Description in spanish"
                      value={formik.values.description?.es}
                      onChange={handleChange}
                    />
                  </Box>
                  {(isEdit || !resource) && (
                    <Typography
                      sx={{
                        color: color4,
                        textAlign: "right",
                        fontWeight: 400,
                        px: 1,
                      }}
                    >
                      {`${limit4} /150`}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: "18px",
                      minWidth: "300px",
                      maxWidth: "600px",
                      marginTop: "10px",
                    }}
                  >
                    Link<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextField
                      type="text"
                      name="link"
                      placeholder="Enter the Link"
                      value={formik.values.link}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.link && Boolean(formik.errors.link)}
                      errorMessage={formik.touched.link && formik.errors.link}
                    />
                    <Typography marginTop={"10px"}>
                      Link/URL should be in the format as
                      https://www.budgetbutterfly.ca
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <DialogActions
              disableSpacing={false}
              sx={{
                ...classes.buttonWrapper,
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              {!isView && (
                <Button
                  style={{
                    marginTop: 0,
                    width: "50%",
                    minWidth: "150px",
                    maxWidth: "150px",
                  }}
                  className="theme-btn-contained theme-btn theme-auth-btn"
                  label={isEdit ? "Update" : "Save"}
                  variant="contained"
                  color="primary"
                  typeButton="submit"
                  disabled={getDisabled()}
                />
              )}
              <Button
                style={{
                  marginTop: 0,
                  width: "50%",
                  minWidth: "150px",
                  maxWidth: "150px",
                }}
                className="theme-btn-contained theme-btn theme-auth-btn"
                label={isView ? "Close" : "Cancel"}
                variant="contained"
                color="primary"
                onClick={closeModalHandler}
              />
            </DialogActions>
          </Box>
        </DialogContent>
      </form>
    </CustomDialog>
  );
}
